import { InstalledIntegrationType } from "@/types/installedintegration";

// Integrations that can be flagged NEEDS_RECONNECT and offer an in-place
// Reconnect on their Settings card. Types missing here are never flagged by
// the backend or cannot reconnect without a destructive Disconnect.
export const RECONNECT_DISPLAY_NAMES: Partial<
  Record<InstalledIntegrationType, string>
> = {
  [InstalledIntegrationType.GOOGLECALENDAR]: "Google calendar",
  [InstalledIntegrationType.MICROSOFTCALENDAR]: "Outlook calendar",
  [InstalledIntegrationType.PARAGON_GOOGLE]: "Google email",
  [InstalledIntegrationType.PARAGON_MICROSOFT]: "Microsoft email",
  [InstalledIntegrationType.PARAGON_SALESFORCE]: "Salesforce",
  [InstalledIntegrationType.PARAGON_XLR8]: "XLR8",
  [InstalledIntegrationType.PARAGON_PRACTIFI]: "Practifi",
  [InstalledIntegrationType.PARAGON_SS_C_BLACKDIAMONDELEMENTS]:
    "SS&C Black Diamond Elements",
  [InstalledIntegrationType.PARAGON_FSC]: "Salesforce FSC",
  [InstalledIntegrationType.PARAGON_MICROSOFTDYNAMICS]:
    "Microsoft Dynamics 365",
  [InstalledIntegrationType.PARAGON_ZOHO]: "Zoho CRM",
  [InstalledIntegrationType.PARAGON_CLOVEN]: "Cloven",
  [InstalledIntegrationType.PARAGON_MAXIMIZER]: "Maximizer CRM",
  [InstalledIntegrationType.PARAGON_EQUISOFT]: "Equisoft",
  [InstalledIntegrationType.LAYLAH]: "Laylah",
};
